import { type Time } from '@internationalized/date';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { DateInput, DateSegment, Label, TimeField } from 'react-aria-components';

/**
 * HourField — the segmented hour picker (react-aria's `TimeField`) shared by `DatePickerShell` (popover pickers)
 * and `DatePickerInline`, so both render the same accessible, `--ui-*`-themed control instead of duplicating it.
 * The public contract stays on `@internationalized/date`'s `Time` (the pickers combine it with the date).
 */

type HourFieldProps = {
  onChange: (time: Time | null) => void;
  value: Time | null;
};

function HourField({ onChange, value }: HourFieldProps): JSX.Element {
  const { t } = useTranslation();

  return (
    <TimeField aria-label={t('common:Hour')} className="date-picker-hour" hourCycle={24} onChange={onChange} value={value}>
      <Label className="date-picker-hour__label">{t('common:Hour')}</Label>
      <DateInput className="date-picker-hour__input">{(segment) => <DateSegment className="date-picker-hour__segment" segment={segment} />}</DateInput>
    </TimeField>
  );
}

export default HourField;
